(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calendly-embed"] && !Shopify.designMode) return;
  try {
    
(() => {
  // If raw embed used, user may already include scripts - don't force load.
  const root = document.getElementById('calendly-{{ section.id }}');
  if (!root) return;

  const hasInlineWidget = root.querySelector('.calendly-inline-widget');
  if (!hasInlineWidget) return;

  // Load Calendly script only once per page
  if (window.__calendlyScriptLoaded) return;

  const s = document.createElement('script');
  s.src = 'https://assets.calendly.com/assets/external/widget.js';
  s.async = true;
  s.onload = () => { window.__calendlyScriptLoaded = true; };
  document.head.appendChild(s);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-links-occasion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-section-id]').forEach(container => {
    const links = container.querySelectorAll('.occasion__link');
    const images = container.querySelectorAll('.occasion__image');

    // Başlangıçta ilk item seçili
    links.forEach((link, i) => {
      link.style.opacity = (i === 0) ? '1' : '0.5';
    });

    links.forEach(link => {
      link.addEventListener('mouseenter', function() {
        const targetId = this.getAttribute('data-target');

        // Background image değiştir
        images.forEach(img => img.classList.remove('is-visible'));
        container.querySelector('#' + targetId).classList.add('is-visible');

        // Title opacity güncelle
        links.forEach(l => l.style.opacity = '0.5');
        this.style.opacity = '1';
        this.style.transform = 'translateX(10px)';
      });

      link.addEventListener('mouseleave', function() {
        // Hover bırakıldığında ilk item default
        images.forEach(img => img.classList.remove('is-visible'));
        images[0].classList.add('is-visible');

        links.forEach((l, i) => {
          l.style.opacity = (i === 0) ? '1' : '0.5';
        });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
